const routes = [
    {
        path: '/checkout/method',
        name: 'method',
        component: () => import(/* webpackChunkName: "/dyn/checkout" */ '#/payment/method'),
        meta: {}
    },
    {
        path: '/checkout/cart',
        name: 'checkout',
        component: () => import(/* webpackChunkName: "/dyn/checkout" */ '#/payment/cart'),
        meta: {},

    },
    {
        path: '/transactions/:userID',
        name: 'transactions',
        component: () => import(/* webpackChunkName: "/dyn/checkout" */ '#/payment/transactions'),
        meta: {},

    }

    ]
export default routes
